// src/pages/admin/adminPageEditor/hooks/useLanguageDict.js
import { useCallback, useEffect, useState } from "react";

export function useLanguageDict({ apiBase, initialLang = "en", forceEnglish = true } = {}) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || initialLang);
  const [dict, setDict] = useState(null);

  // Force language to English (same behavior you had)
  useEffect(() => {
    if (!forceEnglish) return;
    localStorage.setItem("lang", "en");
    document.documentElement.lang = "en";
    document.documentElement.dir = "ltr";
    setLang("en");
  }, [forceEnglish]);

  useEffect(() => {
    let ignore = false;

    async function loadLanguage() {
      try {
        const res = await fetch(`${apiBase}/api/language/${lang}`);
        const data = await res.json();
        if (!ignore) setDict(data || {});
      } catch (err) {
        console.error("Failed to load language:", err);
        if (!ignore) setDict({});
      }
    }

    loadLanguage();
    return () => {
      ignore = true;
    };
  }, [apiBase, lang]);

  const t = useCallback(
    (key, fallback = "") => {
      const value = key.split(".").reduce((acc, part) => acc?.[part], dict);
      return value ?? fallback;
    },
    [dict]
  );

  return { lang, setLang, dict, t };
}